import { render, staticRenderFns } from "./pedidosRealizados.vue?vue&type=template&id=5ee39452&scoped=true&"
import script from "./pedidosRealizados.vue?vue&type=script&lang=js&"
export * from "./pedidosRealizados.vue?vue&type=script&lang=js&"
import style0 from "./pedidosRealizados.vue?vue&type=style&index=0&id=5ee39452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee39452",
  null
  
)

export default component.exports